"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('app_adyen_SFRA/adyen/commons/httpClient'),
  httpClient = _require.httpClient;
var store = require('app_adyen_SFRA/../../../config/store');
var helpers = require('app_adyen_SFRA/adyen/checkout/helpers');
var _require2 = require('app_adyen_SFRA/../../../config/constants'),
  PAYPAL = _require2.PAYPAL;
var _require3 = require('app_adyen_SFRA/adyen/express/initializeCheckout'),
  initializeCheckout = _require3.initializeCheckout;
var _require5 = require('../../../commons/'),
  createPPExpPdpBasket = _require5.createPPExpPdpBasket;

// ### START CUSTOM ADYEN ALPENITE ###
// Helper function to clean up all blur effects
function cleanupPaypalBlurEffects() {
  // Remove blur from main content
  if (window.paypalBlurElement) {
    window.paypalBlurElement.style.filter = 'none';
    window.paypalBlurElement = null;
  }

  // Remove blur from document body
  if (document.body && document.body.style.filter) {
    document.body.style.filter = 'none';
  }

  // Remove blur from any other elements that might have been affected
  var blurredElements = document.querySelectorAll('[style*="blur"]');
  blurredElements.forEach(function(element) {
    if (element.style.filter && element.style.filter.includes('blur')) {
      element.style.filter = 'none';
    }
  });
}
// ### END CUSTOM ADYEN ALPENITE ###

// Counter to track component creation attempts
var componentCreationCounter = 0;

var Paypal = /*#__PURE__*/function () {
  function Paypal(config, applicationInfo, adyenTranslations) {
    _classCallCheck(this, Paypal);

    // Track component creation
    componentCreationCounter++;
    // console.log('🏗️ Paypal constructor called - Instance #' + componentCreationCounter);
    // console.log('  ⏰ Timestamp:', new Date().toISOString());

    var _window = window,
      paypalReviewPageEnabled = _window.paypalReviewPageEnabled,
      returnURL = _window.returnURL,
      basketAmount = _window.basketAmount,
      makeExpressPaymentsCall = _window.makeExpressPaymentsCall,
      saveShopperData = _window.saveShopperData,
      makeExpressPaymentDetailsCall = _window.makeExpressPaymentDetailsCall,
      showConfirmationAction = _window.showConfirmationAction,
      shippingMethodsUrl = _window.shippingMethodsUrl,
      selectShippingMethodUrl = _window.selectShippingMethodUrl,
      saveExpressPaymentDataUrl = _window.saveExpressPaymentDataUrl;
    this.store = store;
    this.helpers = helpers;
    this.returnUrl = returnURL;
    this.amount = JSON.parse(basketAmount);
    this.showPayButton = true;
    this.isExpress = true;
    this.userAction = paypalReviewPageEnabled ? 'continue' : null;
    this.makeExpressPaymentsCallUrl = makeExpressPaymentsCall;
    this.saveShopperDataUrl = saveShopperData;
    this.makeExpressPaymentDetailsCallUrl = makeExpressPaymentDetailsCall;
    this.showConfirmationAction = showConfirmationAction;
    this.shippingMethodsUrl = shippingMethodsUrl;
    this.selectShippingMethodUrl = selectShippingMethodUrl;
    this.saveExpressPaymentDataUrl = saveExpressPaymentDataUrl;
    this.applicationInfo = applicationInfo;
    this.translations = adyenTranslations;
    this.config = config;

    // console.log('  ✅ Paypal instance created');
  }
  return _createClass(Paypal, [{
    key: "callPaymentFromComponent",
    value: function () {
      var _callPaymentFromComponent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(state, component) {
        var response, action;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              // console.log('🚀 PayPal Express Button CLICKED');
              // console.log('  📦 Initial state:', JSON.stringify(state, null, 2));

              // ### START CUSTOM ADYEN ALPENITE ###
              _context.next = 3;
              return createPPExpPdpBasket();
            case 3:
              // Add subtle blur effect to main content only (avoiding cart/navigation)
              var mainContent = document.querySelector('main') || document.querySelector('.main-content') || document.querySelector('.page-content');
              if (mainContent) {
                mainContent.style.filter = 'blur(2px)';
                mainContent.style.transition = 'filter 0.3s ease';
                // Store reference for cleanup
                window.paypalBlurElement = mainContent;
              }
              // ### END CUSTOM ADYEN ALPENITE ###
              $.spinner().start();
              // console.log('  📤 Calling makeExpressPaymentsCall...');
              _context.next = 4;
              return httpClient({
                method: 'POST',
                url: this.makeExpressPaymentsCallUrl,
                data: {
                  data: JSON.stringify(state.data)
                }
              });
            case 4:
              response = _context.sent;
              // console.log('  📥 Response from makeExpressPaymentsCall:', JSON.stringify(response, null, 2));

              action = response.fullResponse.action;
              if (action) {
                // console.log('  ✅ Action received - opening PayPal popup');
                // console.log('  🔍 Action details:', JSON.stringify(action, null, 2));
                // console.log('  🚪 Calling component.handleAction() - POPUP SHOULD OPEN NOW');
                component.handleAction(action);
                // console.log('  ✅ component.handleAction() completed');
              } else {
                // console.error('  ❌ NO ACTION in response');
                //### START CUSTOM ADYEN ALPENITE ###
                // Remove blur effect when no action is returned (error case)
                cleanupPaypalBlurEffects();
                //### END CUSTOM ADYEN ALPENITE ###
                component.handleError();
              }
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              // console.error('  ❌ callPaymentFromComponent ERROR:', _context.t0);
              // console.error('  ❌ Error details:', JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)));
              //### START CUSTOM ADYEN ALPENITE ###
              // Remove blur effect on error
              cleanupPaypalBlurEffects();
              //### END CUSTOM ADYEN ALPENITE ###
              component.handleError(_context.t0);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 9]]);
      }));
      function callPaymentFromComponent(_x, _x2) {
        return _callPaymentFromComponent.apply(this, arguments);
      }
      return callPaymentFromComponent;
    }()
  }, {
    key: "onAuthorized",
    value: function () {
      var _onAuthorized = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data, actions) {
        var _payer$phone, _payer$phone$phone_nu, _payer$name, _payer$name2, _data$authorizedEvent, payer, billingAddress, deliveryAddress, shopperDetails;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // console.log('🎉 PayPal onAuthorized TRIGGERED (User confirmed payment in PayPal)');
              // console.log('  📦 Full data:', JSON.stringify(data, null, 2));
              // console.log('  ⏰ Timestamp:', new Date().toISOString());

              _data$authorizedEvent = data.authorizedEvent.payer, payer = _data$authorizedEvent === void 0 ? {} : _data$authorizedEvent, billingAddress = data.billingAddress, deliveryAddress = data.deliveryAddress;

              // console.log('  👤 Payer:', JSON.stringify(payer, null, 2));
              // console.log('  📍 Delivery Address:', JSON.stringify(deliveryAddress, null, 2));
              // console.log('  💳 Billing Address:', JSON.stringify(billingAddress, null, 2));

              shopperDetails = {
                shopperEmail: payer.email_address,
                telephoneNumber: (_payer$phone = payer.phone) === null || _payer$phone === void 0 ? void 0 : (_payer$phone$phone_nu = _payer$phone.phone_number) === null || _payer$phone$phone_nu === void 0 ? void 0 : _payer$phone$phone_nu.national_number,
                shopperName: {
                  firstName: (_payer$name = payer.name) === null || _payer$name === void 0 ? void 0 : _payer$name.given_name,
                  lastName: (_payer$name2 = payer.name) === null || _payer$name2 === void 0 ? void 0 : _payer$name2.surname
                },
                shippingAddress: deliveryAddress,
                billingAddress: deliveryAddress  //###  CUSTOM ADYEN ALPENITE ###
              };

              // console.log('  💾 Saving shopper details:', JSON.stringify(shopperDetails, null, 2));

              _context2.next = 5;
              return httpClient({
                method: 'POST',
                url: this.saveShopperDataUrl,
                data: {
                  data: JSON.stringify(shopperDetails)
                }
              });
            case 5:
              // console.log('  ✅ Shopper details saved - resolving');
              actions.resolve();
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              // console.error('  ❌ onAuthorized ERROR:', _context2.t0);
              // console.error('  ❌ Error details:', JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)));
              //### START CUSTOM ADYEN ALPENITE ###
              cleanupPaypalBlurEffects();
              //### END CUSTOM ADYEN ALPENITE ###
              $.spinner().stop();
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 8]]);
      }));
      function onAuthorized(_x3, _x4) {
        return _onAuthorized.apply(this, arguments);
      }
      return onAuthorized;
    }()
  }, {
    key: "makeExpressPaymentDetailsCall",
    value: function () {
      var _makeExpressPaymentDetailsCall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data) {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return httpClient({
                method: 'POST',
                url: this.makeExpressPaymentDetailsCallUrl,
                data: {
                  data: JSON.stringify({
                    data: data
                  })
                }
              });
            case 3:
              response = _context3.sent;
              this.helpers.createShowConfirmationForm(this.showConfirmationAction);
              this.helpers.setOrderFormData(response);
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              //### START CUSTOM ADYEN ALPENITE ###
              cleanupPaypalBlurEffects();
              //### END CUSTOM ADYEN ALPENITE ###
              $.spinner().stop();
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 8]]);
      }));
      function makeExpressPaymentDetailsCall(_x5) {
        return _makeExpressPaymentDetailsCall.apply(this, arguments);
      }
      return makeExpressPaymentDetailsCall;
    }()
  }, {
    key: "onShippingContactSelected",
    value: function () {
      var _onShippingContactSelected = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(data, actions, component) {
        var shippingAddress, currentPaymentData, requestBody, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              // console.log('🔔 PayPal onShippingContactSelected TRIGGERED (FIRST CALL when popup opens)');
              // console.log('  📍 Full data received:', JSON.stringify(data, null, 2));

              shippingAddress = data.shippingAddress;
              currentPaymentData = component.paymentData;

              if (shippingAddress) {
                // console.log('  ✅ Shipping Address:', JSON.stringify(shippingAddress, null, 2));
                _context4.next = 5;
                break;
              }
              // console.error('  ❌ NO SHIPPING ADDRESS - Rejecting');
              return _context4.abrupt("return", actions.reject());
            case 5:
              requestBody = {
                paymentMethodType: PAYPAL,
                currentPaymentData: currentPaymentData,
                address: {
                  city: shippingAddress.city,
                  country: shippingAddress.country,
                  countryCode: shippingAddress.countryCode,
                  stateCode: shippingAddress.state,
                  postalCode: shippingAddress.postalCode
                }
              };
              // console.log('  📤 Calling backend /Adyen-ShippingMethods with:', JSON.stringify(requestBody.address, null, 2));
              _context4.next = 8;
              return httpClient({
                method: 'POST',
                url: this.shippingMethodsUrl,
                data: {
                  data: JSON.stringify(requestBody)
                }
              });
            case 8:
              response = _context4.sent;
              // console.log('  📥 Backend response:', JSON.stringify(response, null, 2));

              if (response && response.status === 'success') {
                // console.log('  ✅ Update successful - updating component');
              } else {
                // console.error('  ⚠️ Response status:', response ? response.status : 'NO RESPONSE');
              }

              Paypal.updateComponent(response, component);
              return _context4.abrupt("return", null);
            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](0);
              // console.error('  ❌ onShippingContactSelected ERROR:', _context4.t0);
              // console.error('  ❌ Error details:', JSON.stringify(_context4.t0, Object.getOwnPropertyNames(_context4.t0)));
              return _context4.abrupt("return", actions.reject(data.errors.ADDRESS_ERROR));
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 13]]);
      }));
      function onShippingContactSelected(_x6, _x7, _x8) {
        return _onShippingContactSelected.apply(this, arguments);
      }
      return onShippingContactSelected;
    }()
  }, {
    key: "onShippingAddressChange",
    value: function () {
      var _onShippingAddressChange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(data, actions, component) {
        var shippingAddress, currentPaymentData, requestBody, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              // console.log('🔔 PayPal onShippingAddressChange TRIGGERED (User changed address)');
              // console.log('  📍 Full data received:', JSON.stringify(data, null, 2));

              shippingAddress = data.shippingAddress;
              currentPaymentData = component.paymentData;

              if (shippingAddress) {
                // console.log('  ✅ Shipping Address:', JSON.stringify(shippingAddress, null, 2));
                _context5.next = 5;
                break;
              }
              // console.error('  ❌ NO SHIPPING ADDRESS - Rejecting');
              return _context5.abrupt("return", actions.reject());
            case 5:
              requestBody = {
                paymentMethodType: PAYPAL,
                currentPaymentData: currentPaymentData,
                address: {
                  city: shippingAddress.city,
                  country: shippingAddress.country,
                  countryCode: shippingAddress.countryCode,
                  stateCode: shippingAddress.state,
                  postalCode: shippingAddress.postalCode
                }
              };
              // console.log('  📤 Calling backend /Adyen-ShippingMethods with:', JSON.stringify(requestBody.address, null, 2));
              _context5.next = 8;
              return httpClient({
                method: 'POST',
                url: this.shippingMethodsUrl,
                data: {
                  data: JSON.stringify(requestBody)
                }
              });
            case 8:
              response = _context5.sent;
              // console.log('  📥 Backend response:', JSON.stringify(response, null, 2));

              if (response && response.status === 'success') {
                // console.log('  ✅ Update successful - updating component');
              } else {
                // console.error('  ⚠️ Response status:', response ? response.status : 'NO RESPONSE');
              }

              Paypal.updateComponent(response, component);
              return _context5.abrupt("return", null);
            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](0);
              // console.error('  ❌ onShippingAddressChange ERROR:', _context5.t0);
              // console.error('  ❌ Error details:', JSON.stringify(_context5.t0, Object.getOwnPropertyNames(_context5.t0)));
              return _context5.abrupt("return", actions.reject(data.errors.ADDRESS_ERROR));
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 13]]);
      }));
      function onShippingAddressChange(_x6, _x7, _x8) {
        return _onShippingAddressChange.apply(this, arguments);
      }
      return onShippingAddressChange;
    }()
  }, {
    key: "onShippingOptionsChange",
    value: function () {
      var _onShippingOptionsChange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data, actions, component) {
        var selectedShippingOption, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              // console.log('🔔 PayPal onShippingOptionsChange TRIGGERED');
              // console.log('  📦 Full data received:', JSON.stringify(data, null, 2));

              selectedShippingOption = data.selectedShippingOption;

              if (selectedShippingOption) {
                // console.log('  ✅ Selected shipping option:', JSON.stringify(selectedShippingOption, null, 2));
                _context6.next = 4;
                break;
              }
              // console.error('  ❌ NO SHIPPING OPTION SELECTED - Rejecting');
              return _context6.abrupt("return", actions.reject());
            case 4:
              // console.log('  📤 Calling backend /Adyen-SelectShippingMethod with methodID:', selectedShippingOption.id);
              _context6.next = 6;
              return httpClient({
                method: 'POST',
                url: this.selectShippingMethodUrl,
                data: {
                  data: JSON.stringify({
                    paymentMethodType: PAYPAL,
                    currentPaymentData: component.paymentData,
                    methodID: selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.id
                  })
                }
              });
            case 6:
              response = _context6.sent;
              // console.log('  📥 Backend response:', JSON.stringify(response, null, 2));

              if (response && response.status === 'success') {
                // console.log('  ✅ Shipping method selection successful');
              } else {
                // console.error('  ⚠️ Response status:', response ? response.status : 'NO RESPONSE');
              }

              // ✅ FIX: Update component and return synchronously (no actions.resolve needed)
              Paypal.updateComponent(response, component);

              // console.log('  ✅ Component updated - PayPal SDK should reflect changes now');
              // PayPal SDK will automatically update the UI after updatePaymentData() completes
              return _context6.abrupt("return");
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](0);
              // console.error('  ❌ onShippingOptionsChange ERROR:', _context6.t0);
              // console.error('  ❌ Error details:', JSON.stringify(_context6.t0, Object.getOwnPropertyNames(_context6.t0)));
              return _context6.abrupt("return", actions.reject(data.errors.METHOD_UNAVAILABLE));
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 11]]);
      }));
      function onShippingOptionsChange(_x9, _x0, _x1) {
        return _onShippingOptionsChange.apply(this, arguments);
      }
      return onShippingOptionsChange;
    }()
  }, {
    key: "onAdditionalDetails",
    value: function () {
      var _onAdditionalDetails = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(state, component) {
        var response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              if (!this.userAction) {
                _context7.next = 8;
                break;
              }
              _context7.next = 4;
              return httpClient({
                method: 'POST',
                url: this.saveExpressPaymentDataUrl,
                data: {
                  data: JSON.stringify(state.data)
                }
              });
            case 4:
              response = _context7.sent;
              if (response.success && response.redirectUrl) {
                window.location.href = response.redirectUrl;
              }
              _context7.next = 12;
              break;
            case 8:
              _context7.next = 10;
              return this.makeExpressPaymentDetailsCall(state.data);
            case 10:
              document.querySelector('#additionalDetailsHidden').value = JSON.stringify(state.data);
              document.querySelector('#showConfirmationForm').submit();
            case 12:
              _context7.next = 18;
              break;
            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](0);
              component.handleError(_context7.t0);
              //### START CUSTOM ADYEN ALPENITE ###
              cleanupPaypalBlurEffects();
              // ### END CUSTOM ADYEN ALPENITE ###
              $.spinner().stop();
            case 18:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 14]]);
      }));
      function onAdditionalDetails(_x10, _x11) {
        return _onAdditionalDetails.apply(this, arguments);
      }
      return onAdditionalDetails;
    }()
  }, {
    key: "getConfig",
    value: function getConfig() {
      // Get countryCode from page configuration or locale fallback
      // Priority: window.Configuration.countryCode > locale.slice(-2) > window.countryCode > 'IT'
      var countryCode = (window.Configuration && window.Configuration.countryCode)
        ? window.Configuration.countryCode
        : (window.locale && typeof window.locale === 'string' && window.locale.length >= 2)
          ? window.locale.slice(-2)
          : (window.countryCode)
            ? window.countryCode
            : 'IT'; // Last resort fallback

      // Log warning if using fallback (helps detect configuration issues)
      if (!window.Configuration || !window.Configuration.countryCode) {
        // console.warn('⚠️ PayPal: window.Configuration.countryCode not found, using fallback:', countryCode);
      }

      return _objectSpread(_objectSpread({
        configuration: this.config,
        showPayButton: this.showPayButton,
        returnUrl: this.returnUrl,
        amount: this.amount,
        isExpress: this.isExpress,
        countryCode: countryCode // Add countryCode to tell PayPal which country we're shipping to
      }, this.userAction ? {
        userAction: this.userAction
      } : {}), {}, {
        onSubmit: this.callPaymentFromComponent.bind(this),
        onError: this.onError.bind(this),
        onCancel: this.onCancel.bind(this),
        onAuthorized: this.onAuthorized.bind(this),
        onAdditionalDetails: this.onAdditionalDetails.bind(this),
        onShippingContactSelected: this.onShippingContactSelected.bind(this),
        onShippingAddressChange: this.onShippingAddressChange.bind(this),
        onShippingOptionsChange: this.onShippingOptionsChange.bind(this),
        blockPayPalCreditButton: true,
        blockPayPalPayLaterButton: true,
        style: {
            color: 'white',
            shape: 'sharp',
            disableMaxWidth: true
        }
      });
    }
  }, {
    key: "getComponent",
    value: function () {
      var _getComponent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var checkout, paypalConfig, component;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              // console.log('🔧 getComponent() called - Creating PayPal component - Call #' + componentCreationCounter);
              // console.log('  ⏰ Timestamp:', new Date().toISOString());
              // console.log('  🔍 Is this a RETRY after first attempt?', componentCreationCounter > 1 ? 'YES ⚠️' : 'NO');
              _context7.next = 2;
              return initializeCheckout(this.applicationInfo, this.translations);
            case 2:
              checkout = _context7.sent;
              // console.log('  ✅ Checkout initialized:', !!checkout);
              paypalConfig = this.getConfig();
              // console.log('  ⚙️ PayPal config:', JSON.stringify(paypalConfig, null, 2));
              component = window.AdyenWeb.createComponent(PAYPAL, checkout, paypalConfig);
              // console.log('  ✅ PayPal component created:', !!component);
              return _context7.abrupt("return", component);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getComponent() {
        return _getComponent.apply(this, arguments);
      }
      return getComponent;
    }()
  }, {
    key: "onError",
    value: function onError(error) {
      // console.error('❌ PayPal onError() callback triggered');
      // console.error('  ⏰ Timestamp:', new Date().toISOString());
      // console.error('  📦 Error object:', error);
      // console.error('  📋 Error details:', JSON.stringify(error, Object.getOwnPropertyNames(error), 2));
      // console.error('  🔍 Error type:', typeof error);
      // console.error('  🔍 Error message:', error && error.message ? error.message : 'No message');
      // console.error('  🔍 Error stack:', error && error.stack ? error.stack : 'No stack trace');

      //### START CUSTOM ADYEN ALPENITE ###
      // Remove all blur effects on error
      cleanupPaypalBlurEffects();
      //### END CUSTOM ADYEN ALPENITE ###cleanupPaypalBlurEffects
      $.spinner().stop();

      // console.error('  ✅ Cleanup completed after error');
    }
  }, {
    key: "onCancel",
    value: function onCancel(data, component) {
      // console.warn('⚠️ PayPal onCancel() callback triggered - User closed/cancelled popup');
      // console.warn('  ⏰ Timestamp:', new Date().toISOString());
      // console.warn('  📦 Cancel data:', data);
      // console.warn('  📋 Cancel data JSON:', JSON.stringify(data, null, 2));
      // console.warn('  🔍 Component state:', component);
      // console.warn('  🔍 Was popup closed by user or by system?');

      //### START CUSTOM ADYEN ALPENITE ###
      // Remove all blur effects on cancel
      cleanupPaypalBlurEffects();
      //### END CUSTOM ADYEN ALPENITE ###
      $.spinner().stop();

      // console.warn('  ✅ Cleanup completed after cancel');
    }
  }], [{
    key: "updateComponent",
    value: function updateComponent(response, component) {
      // console.log('🔄 updateComponent called');
      // console.log('  📥 Response:', JSON.stringify(response, null, 2));

      if (response) {
        var paymentData = response.paymentData,
          status = response.status,
          shippingMethods = response.shippingMethods,
          _response$errorMessag = response.errorMessage,
          errorMessage = _response$errorMessag === void 0 ? '' : _response$errorMessag;

        // console.log('  📊 Status:', status);
        // console.log('  💳 Has paymentData:', !!paymentData);

        // 🚨 DROPDOWN SHIPPING METHODS LOGGING
        // ✅ FIX: Check shipments[0].shippingMethods (actual location) instead of response.shippingMethods
        var actualShippingMethods = response.shipments && response.shipments[0] && response.shipments[0].shippingMethods;
        // console.log('  🚢 SHIPPING METHODS CHECK:');
        // console.log('    📦 Has shipments in response:', !!response.shipments);
        // console.log('    🔢 Number of shipping methods:', actualShippingMethods ? actualShippingMethods.length : 0);
        // if (actualShippingMethods && actualShippingMethods.length > 0) {
        //   console.log('    📋 Shipping methods details:', JSON.stringify(actualShippingMethods, null, 2));
        //   console.log('    ⚠️  MULTIPLE METHODS: Dropdown SHOULD appear in PayPal popup!');
        //   actualShippingMethods.forEach(function(method, index) {
        //     console.log('      Method #' + (index + 1) + ':', method.ID, '-', method.displayName, '- Selected:', method.selected);
        //   });
        // } else {
        //   console.log('    ℹ️  SINGLE OR NO METHOD: No dropdown needed');
        // }

        if (!paymentData || status !== 'success') {
          // console.error('  ❌ Update failed:', errorMessage);
          throw new Error(errorMessage);
        }

        // console.log('  ✅ Updating PayPal component with new paymentData');
        // console.log('  🔧 Calling component.updatePaymentData() - This should trigger PayPal SDK to show dropdown');
        // Update the Component paymentData value with the new one.
        component.updatePaymentData(paymentData);
        // console.log('  ✅ component.updatePaymentData() completed');
      } else {
        var _response$errorMessag2 = response.errorMessage,
          _errorMessage = _response$errorMessag2 === void 0 ? '' : _response$errorMessag2;
        // console.error('  ❌ NO RESPONSE received');
        throw new Error(_errorMessage);
      }
      return false;
    }
  }]);
}();
module.exports = Paypal;
